// when adding more sources, add mocks for added modules
export enum StoreModulesNamesEnum {
  Notifications = 'Notifications',
  MeasurementUnits = 'MeasurementUnits',
  Admin = 'Admin',
  Spatial = 'Spatial',
  Company = 'Company',
  Settings = 'Settings',
  FiltersData = 'FiltersData',
  TableOptions = 'TableOptions',
  Lists = 'Lists',
  Views = 'Views',
  GroupFilters = 'GroupFilters',
  LeaseIngestion = 'LeaseIngestion',
  AvailabilityIngestion = 'AvailabilityIngestion',
  ListsDashboards = 'ListsDashboards',
  Task = 'Task',
  // The members/ directory module; `Members` (the legacy modules/members.js
  // file) is the un-namespaced photo-cropper state registered right above it.
  Member = 'Member',
} // todo: add more modules here
